const LARGURA_MINIMA_ABA_MES = 56;

export const colunasAbasMes = (quantidade: number, largura: number): number => {
  if (quantidade <= 1) {
    return 1;
  }
  if (largura <= 0 || largura >= quantidade * LARGURA_MINIMA_ABA_MES) {
    return quantidade;
  }
  return Math.ceil(quantidade / 2);
};
